import { useEffect, useState } from 'react';

// Flags a number-of-shares value below the 1-share minimum. An empty field only counts once the
// user has cleared it themselves, so the error doesn't show when the form opens or is reset.
const useShareCountValidation = (numberOfShare) => {
  const [isClearedByUser, setIsClearedByUser] = useState(false);

  useEffect(() => {
    if (numberOfShare) {
      setIsClearedByUser(false);
    }
  }, [numberOfShare]);

  const isBelowMinShares = numberOfShare ? Number(numberOfShare) < 1 : isClearedByUser;

  const onShareInputChange = (value) => setIsClearedByUser(value === '');

  return { isBelowMinShares, onShareInputChange };
};

export default useShareCountValidation;
